import React from "react";
import { Box, Button, IconButton } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import LogoMark from "../LogoMark";
import CustomHamburgerIcon from "./CustomHamburgerIcon";
import CartIconButton from "./CartIconButton";

const MobileHeader = ({ onOpenDrawer }) => {
  const { user, isAuthenticated } = useAuth();

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fff",
        position: "sticky",
        top: 0,
        zIndex: 1200,
        borderBottom: "1px solid #eee",
      }}>
      {/* Row 2: Logo Mark on left, actions on right */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1,
          px: 1,
        }}>
        <LogoMark onClick={() => navigate("/")} />

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {user && isAuthenticated ? (
            <>
              <CartIconButton />
              <IconButton onClick={onOpenDrawer}>
                <CustomHamburgerIcon />
              </IconButton>
            </>
          ) : (
            <>
              <Button
                onClick={() => navigate("/login")}
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#1A1A1A",
                  px: 0,
                  "&:hover": { color: "#FD7762" },
                }}>
                Log In
              </Button>
              <Button
                onClick={() => navigate("/signup")}
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#1A1A1A",
                  px: 0,
                  "&:hover": { color: "#FD7762" },
                }}>
                Sign Up
              </Button>
              <CartIconButton onClick={() => navigate("/cart")} />
              <IconButton onClick={onOpenDrawer}>
                <CustomHamburgerIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MobileHeader;
